const theme = {
  colors: {
    base: '#4a4a4a', // Dark Gray
    secondary: '#edebe8', // Light BCCA Red
    tertiary: '#e0dcd7', // Medium Gray
    highlight: '#aaaea2', // Forrest Green
    bcca: '#8b0e04', // BCCA Red
  },
  sizes: {
    maxWidth: '1200px',
  },
  responsive: {
    small: '30em',
    medium: '50em',
    large: '100em',
  },
}

export default theme



// WEBPACK FOOTER //
// ./src/styles/theme.js